/* eslint-disable import/prefer-default-export */
export const INPUT_DEBOUNCE_DELAY = 500;
